import React from 'react';
import {
  SMS_CONSENT_PRIVACY_HREF,
  SMS_CONSENT_TERMS_HREF,
} from './SmsConsentNotice';

export const KEYFLO_TERMS_HREF = SMS_CONSENT_TERMS_HREF;
export const KEYFLO_PRIVACY_HREF = SMS_CONSENT_PRIVACY_HREF;

const checkboxLabelStyle = {
  display: 'flex',
  gap: '10px',
  alignItems: 'flex-start',
  marginTop: '16px',
  marginBottom: '8px',
  lineHeight: 1.5,
  cursor: 'pointer',
};

function stopLabelToggle(event) {
  event.stopPropagation();
}

export function PaymentLegalAcceptanceCheckbox({
  checked,
  onChange,
  id = 'payment-legal-acceptance',
}) {
  return (
    <label
      htmlFor={id}
      data-testid="payment-legal-acceptance"
      style={checkboxLabelStyle}
    >
      <input
        id={id}
        type="checkbox"
        required
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        style={{ marginTop: '4px' }}
      />
      <span>
        I have read and accept the KeyFlo{' '}
        <a
          href={KEYFLO_TERMS_HREF}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stopLabelToggle}
        >
          Terms of Service
        </a>
        {' '}and{' '}
        <a
          href={KEYFLO_PRIVACY_HREF}
          target="_blank"
          rel="noopener noreferrer"
          onClick={stopLabelToggle}
        >
          Privacy Policy
        </a>
        {'.'}
      </span>
    </label>
  );
}

export function paymentSetupSubmitEnabled({
  stripeReady,
  submitting,
  trialAcknowledged,
  legalAccepted,
}) {
  return Boolean(stripeReady && !submitting && trialAcknowledged && legalAccepted);
}
